<div class="space-y-6">
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">SOS Alerts</h2>
      <p class="text-sm text-gray-500 mt-1">Manage emergency alerts from users.</p>
    </div>
    <button
      (click)="loadAlerts()"
      class="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition">
      Refresh
    </button>
  </div>

  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadAlerts()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <div *ngIf="!isLoading && !errorMessage" class="bg-white rounded-2xl shadow overflow-hidden border border-red-100">
    <table class="w-full text-sm">
      <thead class="bg-red-50 text-left text-red-900 border-b border-red-100">
        <tr>
          <th class="p-4">Alert ID</th>
          <th>User</th>
          <th>Location</th>
          <th>Created At</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let alert of alerts" class="border-t hover:bg-red-50/50">
          <td class="p-4 font-medium text-gray-800">#{{ alert.id }}</td>
          <td>
             <p class="font-medium text-gray-800" *ngIf="alert.user">{{ alert.user.name }}</p>
             <p class="text-xs text-gray-500" *ngIf="alert.user">{{ alert.user.phone }}</p>
             <span *ngIf="!alert.user" class="text-gray-400 italic">Unknown</span>
          </td>
          <td>
             <a target="_blank" [href]="'https://www.google.com/maps/search/?api=1&query=' + alert.latitude + ',' + alert.longitude" class="text-blue-600 hover:underline flex items-center gap-1">
               📍 View Map
             </a>
             <p class="text-xs text-gray-500 mt-1">{{ alert.latitude | number:'1.2-4' }}, {{ alert.longitude | number:'1.2-4' }}</p>
          </td>
          <td class="text-gray-600">{{ alert.created_at | date:'short' }}</td>
          <td>
            <span [ngClass]="alert.status === 'active' ? 'bg-red-100 text-red-800 border-red-200 animate-pulse' : 'bg-green-100 text-green-800 border-green-200'" class="px-2 py-1 rounded-full text-xs font-medium border uppercase tracking-wider">
              {{ alert.status }}
            </span>
          </td>
          <td>
             <button *ngIf="alert.status === 'active'"
                (click)="resolveAlert(alert)"
                [disabled]="updatingAlertId === alert.id"
                class="px-3 py-1 bg-green-600 text-white rounded text-xs font-medium hover:bg-green-700 disabled:opacity-50">
                Resolve
             </button>
             <span *ngIf="alert.status === 'resolved'" class="text-gray-400 text-xs italic">Resolved</span>
          </td>
        </tr>
        <tr *ngIf="alerts.length === 0">
          <td colspan="6" class="p-8 text-center text-gray-500">No SOS alerts found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
